
import { motion } from "framer-motion";

export const LoanBenefitsSection = () => {
  return (
    <motion.div
      className="bg-gradient-to-br from-blue-100 via-white to-blue-50 p-6 md:p-8 rounded-2xl mb-8 border border-blue-100 shadow-lg relative z-10"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.1 }}
    >
      <h2 className="text-xl font-semibold mb-4 text-blue-700">Säästä rahaa kilpailuttamalla lainasi</h2>
      <p className="text-gray-700 mb-4">Lainasampo.fi:n avulla voit kilpailuttaa lainasi helposti ja nopeasti. Täytä yksi hakemus ja odota mahdolliset tarjoukset eri pankeilta.</p>
      <p className="text-gray-700 mb-4">
        Palvelumme on täysin maksuton sinulle, ja sen käyttäminen ei sido sinua mihinkään.
        Vertailemalla eri pankkien tarjouksia voit säästää jopa tuhansia euroja lainasi kokonaiskustannuksissa.
      </p>
      <p className="text-gray-700">
        Lainasampo.fi palvelee kaikkialla Suomessa, ja saat lainatarjoukset yleensä jo saman päivän aikana.
      </p>
    </motion.div>
  );
};
